
























import { Action, RootAction } from '@/features/core/store';
import { AddToastMessageParams } from '@/features/core/store/toast';
import { StringProp } from '@/util/prop-decorators';
import { Component, Vue } from 'vue-property-decorator';
import { AppCustomerNukiSmartlockTableFragment } from '../../../components/nuki-smartlock-table/__generated__/AppCustomerNukiSmartlockTableFragment';
import disconnectMutation from './disconnect.gql';
import query from './view.gql';
import {
  AppCustomerNukiApiConnectedSmartlocksViewDisconnectMutation,
  AppCustomerNukiApiConnectedSmartlocksViewDisconnectMutationVariables,
} from './__generated__/AppCustomerNukiApiConnectedSmartlocksViewDisconnectMutation';
import {
  AppCustomerNukiApiConnectedSmartlocksViewQuery,
  AppCustomerNukiApiConnectedSmartlocksViewQueryVariables,
} from './__generated__/AppCustomerNukiApiConnectedSmartlocksViewQuery';

type Smartlock = AppCustomerNukiSmartlockTableFragment;

@Component({
  apollo: {
    customers: {
      query,
      fetchPolicy: 'cache-and-network',
      variables(this: ConnectedSmartlocksView): AppCustomerNukiApiConnectedSmartlocksViewQueryVariables {
        return { customerId: this.customerId, nukiApiId: this.vendorApiId };
      },
    },
  },
  data() {
    return { customers: undefined };
  },
})
export default class ConnectedSmartlocksView extends Vue {
  @RootAction
  private readonly ADD_TOAST_MESSAGES!: Action<AddToastMessageParams, void>;

  @StringProp(true)
  private readonly customerId!: string;

  @StringProp(true)
  private readonly vendorApiId!: string;

  private readonly customers?: AppCustomerNukiApiConnectedSmartlocksViewQuery['customers'];

  private get connectedSmartlocks(): AppCustomerNukiSmartlockTableFragment[] {
    return this.customers?.first.nukiApis.first.connectedSmartlocks.items ?? [];
  }

  public async disconnect(smartlock: Smartlock): Promise<void> {
    if (!window.confirm('Wollen Sie die Verknüpfung der Nuki-Schließanlage wirklich trennen?')) {
      return;
    }

    const { data } = await this.$apollo.mutate<
      AppCustomerNukiApiConnectedSmartlocksViewDisconnectMutation,
      AppCustomerNukiApiConnectedSmartlocksViewDisconnectMutationVariables
    >({
      mutation: disconnectMutation,
      variables: { input: { smartlockId: parseInt(smartlock.id) } },
    });

    if (!data) {
      throw new Error('Die Verknüpfung der Nuki-Schließanlage konnte nicht getrennt werden.');
    }

    const text = `Die Verknüpfung der Nuki-Schließanlage "${smartlock.id}" wurde getrennt.`;
    this.ADD_TOAST_MESSAGES({ messages: [{ text }] });

    this.$emit('nuki-smartlock-disconnected', smartlock);

    this.$apollo.queries.customers.refetch();
  }
}
